import React, { useContext } from "react";
import { Cesium1Set, RendouSet } from "../App";
import { SyukurenSet } from "../App";
import { Rotate1Set, Rotate2Set, Zoomhanrei1Set, Zoomlevel1Set,Zoomlevel2Set } from "../App";
import { useEffect } from "react";
import {
  Cartesian3,
  Entity as cesiumEntity,
  HeadingPitchRange,
  ScreenSpaceEventHandler,
  ScreenSpaceEventType,
  Math as Cesium_Math,
} from "cesium";

// 20221231完成
// コントロールキーを押している間、キーボード操作が可能になります
// 20220111完成
// シフトキーを押している間、キーボード操作が可能になります

function getFlagForKeyCode(keyCode) {
  switch (keyCode) {
    case "W".charCodeAt(0):
      return "moveForward";
    case "S".charCodeAt(0):
      return "moveBackward";
    case "Q".charCodeAt(0):
      return "moveUp";
    case "E".charCodeAt(0):
      return "moveDown";
    case "D".charCodeAt(0):
      return "moveRight";
    case "A".charCodeAt(0):
      return "moveLeft";
      // シフトキー：16
      // コントロールキー：17
    case 16:
      return "moveOnoff";
    default:
      return undefined;
  }
}


export const FunkMovebyKey =({rfcs}) =>{
  const { rotate1set, setRotate1Set } = useContext(Rotate1Set);
  const { rotate2set, setRotate2Set } = useContext(Rotate2Set);

  useEffect(() => {

  if(rfcs && rfcs.current ){
    let viewer = rfcs.current.cesiumElement;
    const scene = viewer.scene;
    const canvas = viewer.canvas;
    canvas.setAttribute("tabindex", "0"); // needed to put focus on the canvas
    canvas.onclick = function () {
      canvas.focus();
    };
    const ellipsoid = scene.globe.ellipsoid;
  
    let startMousePosition;
    let mousePosition;
    const flags = {
      looking: false,
      moveForward: false,
      moveBackward: false,
      moveUp: false,
      moveDown: false,
      moveLeft: false,
      moveRight: false,
      moveOnoff: false,
    };
    const handler = new ScreenSpaceEventHandler(canvas);

    handler.setInputAction(function (movement) {
      flags.looking = true;
      mousePosition = startMousePosition = Cartesian3.clone(
        movement.position
      );
    }, ScreenSpaceEventType.LEFT_DOWN);

    handler.setInputAction(function (movement) {
      mousePosition = movement.endPosition;
    }, ScreenSpaceEventType.MOUSE_MOVE);
  
    handler.setInputAction(function (position) {
      flags.looking = false;
    }, ScreenSpaceEventType.LEFT_UP);

    document.addEventListener(
      "keydown",
      function (e) {
        // console.log(e);
        const flagName = getFlagForKeyCode(e.keyCode);
        if (typeof flagName !== "undefined") {
          flags[flagName] = true;
        }
      },
      false
    );

    document.addEventListener(
      "keyup",
      function (e) {
        const flagName = getFlagForKeyCode(e.keyCode);

        if (typeof flagName !== "undefined") {
          flags[flagName] = false;
        }
      },
      false
    );

    viewer.clock.onTick.addEventListener(function (clock) {
      const camera = viewer.camera;
      if(flags.moveOnoff){
        setRotate1Set(false)
        setRotate2Set(false)
        // disable the default event handlers
        scene.screenSpaceCameraController.enableRotate = false;
        scene.screenSpaceCameraController.enableTranslate = false;
        scene.screenSpaceCameraController.enableZoom = false;
        scene.screenSpaceCameraController.enableTilt = false;
        scene.screenSpaceCameraController.enableLook = false;

        if (flags.looking) {
          const width = canvas.clientWidth;
          const height = canvas.clientHeight;
          
          // Coordinate (0.0, 0.0) will be where the mouse was clicked.
          const x = (mousePosition.x - startMousePosition.x) / width;
          const y = -(mousePosition.y - startMousePosition.y) / height;
          
          const lookFactor = 0.05;
          camera.lookRight(x * lookFactor);
          camera.lookUp(y * lookFactor);
        }
    
        // Change movement speed based on the distance of the camera to the surface of the ellipsoid.
        const cameraHeight = ellipsoid.cartesianToCartographic(
          camera.position
        ).height;
        const moveRate = cameraHeight / 3000.0;
      
        if (flags.moveForward) { camera.moveForward(moveRate);}
        if (flags.moveBackward) { camera.moveBackward(moveRate);}
        if (flags.moveUp) { camera.moveUp(moveRate);}
        if (flags.moveDown) { camera.moveDown(moveRate);}
        if (flags.moveLeft) { camera.moveLeft(moveRate);}
        if (flags.moveRight) { camera.moveRight(moveRate);}
      } else {
        // able the default event handlers
        // handler.destroy();
        scene.screenSpaceCameraController.enableRotate = true;
        scene.screenSpaceCameraController.enableTranslate = true;
        scene.screenSpaceCameraController.enableZoom = true;
        scene.screenSpaceCameraController.enableTilt = true;
        scene.screenSpaceCameraController.enableLook = true;
      }
    });

    // 効かない、、、
    // return () => {
    //   handler.destroy();
    // };

  }
}, []);

return <></>
}